
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import less from 'less'
import VueClipboard from 'vue-clipboard2';

Vue.use(VueClipboard);

import './util/flexible'

Vue.prototype.$axios = axios;

Vue.use(MintUI)
Vue.use(less)
Vue.use(ElementUI);

Vue.config.productionTip = false

// import initWx from "./util/weixin.config";
// Vue.use(initWx);
// Vue.config.ignoredElements = ['wx-open-launch-weapp']


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js